import { Navigate, Route, Routes } from "react-router-dom";
import React, { useContext, Suspense, useEffect, useState } from "react";
import { AuthContext } from "./context/AuthContext";
import LoadingImg from "./assets/Loading.gif";

// scss

// import './styles/index.scss';
import { apisPath, paths } from "./utils/path";
import CancelApplication from "./components/CancelApplication/CancelApplication";
// import TempLogin from "./components/TempLogin/TempLogin";
import AdminDashboardLayout from "./shared/AdminDashboardLayout/AdminDashboardLayout";
import UserDashboard from "./Admin/components/UserDashboard/UserDashboard";
import AdminSearchDetails from "./Admin/components/AdminSearchDetails/AdminSearchDetails";
import DownloadData from "./Admin/components/DownloadData/DownloadData";
import Payment from "./Admin/components/Payment/Payment";
import Degree from "./Admin/components/Degree/Degree";
import PrintPaymentSlip from "./Admin/components/PrintPaymentSlip/PrintPaymentSlip";
// import ObjectionLogin from "./components/Objection/Login/ObjectionLogin";
// import ObjectionStepper from "./components/Objection/ObjectionStepper/ObjectionStepper";
// import CandidateInformation from "./components/Objection/CandidateInformation/CandidateInformation";
import http from "./components/services/utility";
// import PersonalInformation from "./components/Objection/ObjectionPersonalInfo/ObjectionPersonalInfo";
// layouts

const Login = React.lazy(() => import("./components/Login/Login"));
const CloseExamDate = React.lazy(() =>
  import("./components/Dashboard/CloseExamDate/CloseExamDate")
);
const HelpDesk = React.lazy(() => import("./components/HelpDesk/HelpDesk"));
const ContactUs = React.lazy(() => import("./components/ContactUs/ContactUs"));
const Frontlayout = React.lazy(() =>
  import("./shared/FrontLayout/Frontlayout")
);
const Instructions = React.lazy(() =>
  import("./shared/Instructions/Instructions")
);
const ExamForm = React.lazy(() => import("./components/ExamForm/ExamForm"));
const ImportantDates = React.lazy(() =>
  import("./components/ImportantDates/ImportantDates")
);
const ForgetPassword = React.lazy(() =>
  import("./components/ForgetPassword/ForgetPassword")
);

const ConfirmPayment = React.lazy(() =>
  import("./components/Dashboard/ConfirmPayment/ConfirmPayment")
);
const PaymentConfirmationDetails = React.lazy(() =>
  import(
    "./components/Dashboard/PaymentConfirmationDetails/PaymentConfirmationDetails"
  )
);

const NotificationTable = React.lazy(() =>
  import("./components/NotificationTable/NotificationTable")
);
const Dashboard = React.lazy(() => import("./components/Dashboard/Dashboard"));
// const AdmitCard = React.lazy(() => import("./components/AdmitCard/AdmitCard"));
const ResetPassword = React.lazy(() =>
  import("./components/ResetPassword/ResetPassword")
);

const PrintConfirm = React.lazy(() =>
  import("./components/Dashboard/CloseExamDate/CloseExamDate")
);

const LoginInstruction = React.lazy(() =>
  import("./components/LoginInstruction/LoginInstruction")
);
const FinalConfirmation = React.lazy(() =>
  import("./components/Dashboard/FinalPreview/FinalPreview")
);
const ConfirmApplication = React.lazy(() =>
  import("./components/Dashboard/ConfirmApplication/ConfirmApplication")
);
// const OmrSheet = React.lazy(() => import("./components/OmrSheet/OmrSheet"));
// const FrontHome = React.lazy(() => import("./components/FrontHome/FrontHome"));

// const AdminDashboard = React.lazy(() =>
//   import("./Admin/AdminDashboard/AdminDashboard")
// );

const AdminCandidateInfo = React.lazy(() =>
  import("./Admin/components/CandidateInfoModal/CandidateInfoModal")
);

const AdminLogin = React.lazy(() =>
  import("./Admin/components/AdminLogin/AdminLogin")
);
const ReUploadImage = React.lazy(() =>
  import("./Admin/components/ReUploadImage/ReUploadImage")
);

const Subject = React.lazy(() => import("./Admin/components/AddSubject/AddSubject"));

// ----------------------------------------------------------------------

export default function Router() {
  const { auth, candidateAuth, isRoutesOpen, setIsRoutesOpen } = useContext(AuthContext);
  // const isLogin = sessionStorage.getItem("token") || 0;
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    if (auth || candidateAuth) {
      http
        .get(apisPath?.front?.isApplicaionOpen)
        .then((res) => {
          setIsRoutesOpen((prev) => ({
            ...prev,
            isAppOpen: res?.data?.is_open,
            isAdmitCardOpen: res?.data?.is_admit_card_open,
            isObjectionOpen: res?.data?.is_objection_open,
            isEditAppOpen: res?.data?.is_edit_application_open,
          }));
          setIsLoading(false);
        })
        .catch(() => {
          setIsRoutesOpen((prev) => ({
            ...prev,
            isAppOpen: false,
            isAdmitCardOpen: false,
            isObjectionOpen: false,
            isEditAppOpen: false,
          }));
          setIsLoading(false);
        });
    }
  }, [auth, candidateAuth]);

  const loading = (
    <div className="loading">
      <span>
        <img src={LoadingImg} alt="loading img" className="circle-process" />
      </span>
      <h1>Loading...</h1>
    </div>
  );
  return (
    <Suspense fallback={loading}>
      {isLoading ? (
        <Routes>
          <Route path="*" element={loading} />
        </Routes>
      ) : (
        <Routes>
          {/* {!isLogin ? (
            <Route path={paths?.front?.commonPoint} element={<TempLogin />} />
          ) : ( */}
          <>
            <Route path={paths?.admin?.commonPoint}>
              {auth !== "logout" ? (
                <>
                  <Route
                    path={paths?.admin?.user?.commonPoint}
                    element={<AdminDashboardLayout />}
                  >
                    <Route
                      path={paths?.admin?.user?.dashboard}
                      element={<UserDashboard />}
                    />
                    <Route
                      path={paths?.admin?.user?.candidates}
                      element={<AdminSearchDetails />}
                    />
                    <Route
                      path={paths?.admin?.user?.candidateInfo}
                      element={<AdminCandidateInfo />}
                    />
                    <Route
                      path={paths?.admin?.user?.printView}
                      element={<PrintPaymentSlip />}
                    />
                    <Route
                      path={paths?.admin?.user?.reUploadImage}
                      element={<ReUploadImage />}
                    />
                    <Route
                      path={paths?.admin?.user?.downloadData}
                      element={<DownloadData />}
                    />
                    <Route
                      path={paths?.admin?.user?.payment}
                      element={<Payment />}
                    />
                    <Route
                      path={paths?.admin?.user?.degree}
                      element={<Degree />}
                    />
                    <Route
                      path={paths?.admin?.user?.subject}
                      element={<Subject />}
                    />

                    {/* <Route path={"/admin/login"} element={<AdminLogin />} /> */}
                    <Route
                      path=""
                      element={
                        <Navigate
                          to={`${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.dashboard}`}
                        />
                      }
                    />
                    <Route
                      path="*"
                      element={
                        <Navigate
                          to={`${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.dashboard}`}
                        />
                      }
                    />

                    {/* <Route path="*" element={<NotFound />} /> */}
                  </Route>
                  <Route
                    path=""
                    element={
                      <Navigate
                        to={`${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.dashboard}`}
                      />
                    }
                  />
                </>
              ) : (
                <>
                  <Route
                    path={paths?.admin?.login}
                    element={<AdminLogin />}
                  />
                  {/* <Route path={paths?.admin?.forgotPassword} element={<ForgotPassword />} />
                  <Route path={paths?.admin?.resetPassword} element={<ResetPassword />} />
                  <Route path={paths?.admin?.register} element={<Register />} />
                  <Route path="" element={<Navigate to={paths?.admin?.login} />}>
                    <Route path="404" element={<NotFound />} />
                    <Route path="*" element={<Navigate to={paths?.admin?.login} />} />
                  </Route> */}
                  <Route
                    path=""
                    element={<Navigate to={`${paths?.admin?.login}`} />}
                  />
                  <Route
                    path="*"
                    element={<Navigate to={`${paths?.admin?.login}`} />}
                  />
                </>
              )}
            </Route>
            <Route
              path={paths?.front?.commonPoint}
              element={<Frontlayout />}
            >
              <Route path={paths?.front?.contactUs} element={<ContactUs />} />
              <Route path={paths?.front?.helpdesk} element={<HelpDesk />} />
              {(!isRoutesOpen?.isAppOpen && !isRoutesOpen?.isEditAppOpen) ? (
                <>
                  <Route
                    path={paths?.front?.importantDates}
                    element={<ImportantDates />}
                  />
                  <Route path="" element={<CloseExamDate />} />
                  <Route path="*" element={<Navigate to={paths?.front?.commonPoint} />} />
                </>
              ) : (
                <>
                  {candidateAuth ? (
                    <>
                      <Route
                        path={paths?.front?.user?.dashboard}
                        element={<Dashboard />}
                      />
                      <Route
                        path={paths?.front?.user?.paymentStatus}
                        element={<PaymentConfirmationDetails />}
                      />
                      <Route
                        path={paths?.front?.user?.confirmApplication}
                        element={<ConfirmApplication />}
                      />
                      <Route
                        path={paths?.front?.user?.confirmPayment}
                        element={<ConfirmPayment />}
                      />
                      <Route
                        path={paths?.front?.user?.finalconfirmation}
                        element={<FinalConfirmation />}
                      />
                      <Route
                        path={paths?.front?.user?.printApplication}
                        element={<PrintConfirm />}
                      />
                      {isRoutesOpen?.isAppOpen &&
                        <Route
                          path={paths?.front?.user?.cancelApplication}
                          element={<CancelApplication />}
                        />
                      }
                      <Route
                        path={paths?.front?.commonPoint}
                        element={
                          <Navigate
                            to={`${paths?.front?.commonPoint !== "/"
                              ? `${paths?.front?.commonPoint}/`
                              : paths?.front?.commonPoint
                              }${paths?.front?.user?.dashboard}`}
                          />
                        }
                      />
                      <Route
                        path="*"
                        element={
                          <Navigate
                            to={`${paths?.front?.commonPoint !== "/"
                              ? `${paths?.front?.commonPoint}/`
                              : paths?.front?.commonPoint
                              }${paths?.front?.user?.dashboard}`}
                          />
                        }
                      />
                    </>
                  ) : (
                    <>
                      <Route path={paths?.front?.login} element={<Login />} />
                      {isRoutesOpen?.isAppOpen &&
                        <>
                          <Route
                            path={paths?.front?.commonPoint}
                            element={<Instructions />}
                          />
                          <Route
                            path={paths?.front?.howToApply}
                            element={<Instructions />}
                          />
                          <Route
                            path={paths?.front?.register}
                            element={<ExamForm />}
                          />
                          <Route
                            path={paths?.front?.logininstruction}
                            element={<LoginInstruction />}
                          />
                        </>
                      }
                      <Route
                        path={paths?.front?.importantDates}
                        element={<ImportantDates />}
                      />
                      <Route
                        path={paths?.front?.forgotPassword}
                        element={<ForgetPassword />}
                      />
                      <Route
                        path={paths?.front?.resetPassword}
                        element={<ResetPassword />}
                      />
                      {/* <Route
                        path={paths?.front?.notification}
                        element={<NotificationTable />}
                      /> */}
                      <Route
                        path={paths?.front?.commonPoint}
                        element={
                          <Navigate
                            to={`${paths?.front?.commonPoint !== "/"
                              ? `${paths?.front?.commonPoint}/`
                              : paths?.front?.commonPoint
                              }${paths?.front?.login}`}
                          />
                        }
                      />
                      <Route
                        path="*"
                        element={
                          <Navigate
                            to={`${paths?.front?.commonPoint !== "/"
                              ? `${paths?.front?.commonPoint}/`
                              : paths?.front?.commonPoint
                              }${paths?.front?.login}`}
                          />
                        }
                      />
                      {/* <Route path="*" element={<Navigate to={`${paths?.front?.commonPoint}`} />} /> */}
                    </>
                  )}
                </>
              )}
            </Route>
          </>
          {/* )} */}
        </Routes>
      )}
    </Suspense>
  );
}
